/**
 * Pipedrive Webforms Module
 *
 * Consent und Laden des Pipedrive-Loader-Scripts werden in @lib/consent gesteuert.
 * Dieses Modul wird für [data-module="pipedrive-webforms"] registriert;
 * nach Freigabe setzt consent.ts data-consent-given="true" und injiziert
 * <script src="https://webforms.pipedrive.com/f/loader"></script>.
 * Der Loader rendert Formulare in Elementen mit [data-pd-webforms].
 */
export default function () {
  // Consent-UI und Script-Injection erfolgen in @lib/consent.
}
